/**
 * Непустая строка как есть, иначе `undefined`.
 *
 * Явная замена `text || undefined`: пустая строка с формы или из ответа бэка так же
 * считается «нет значения», как `null` и `undefined`, — а Sonar не путает это с
 * `??`, который пустую строку пропустил бы дальше.
 */
export function nonEmpty(value: string | null | undefined): string | undefined {
  if (!value) return undefined;
  return value;
}
